import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Cancel} from '@material-ui/icons';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';

class BasicTextArea extends Component {
    state = {
        emptyValidation: true,
        focus: false,
        firstAssignValue: true,
    };

    componentDidMount() {
        const {defalutValue} = this.props;
        if (defalutValue && defalutValue.length > 0) {
            this.input.value = defalutValue;
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.input) {
            if (
                this.state.firstAssignValue &&
                util.isString(nextProps.defalutValue)
            ) {
                this.input.value = nextProps.defalutValue;
                this.props.inputValid(this.props.title, nextProps.defalutValue);

                this.setState({
                    firstAssignValue: false,
                });
            } else if (
                nextProps.value !== this.input.value &&
                util.isString(nextProps.value)
            ) {
                this.input.value = nextProps.value;
            }
        }
    }

    clearInput = () => {
        this.input.value = '';

        this.props.inputValid(this.props.title, '');
        if (this.props.clearInput) {
            this.props.clearInput();
        }
    };

    foucusInput = () => {
        this.setState({
            focus: true,
        });

        if (util.isFunction(this.props.blurFoucus)) {
            this.props.blurFoucus();
        }
    };

    blurAction = () => {
        setTimeout(() => {
            this.setState({
                focus: false,
            });
            if (util.isFunction(this.props.blurAction)) {
                this.props.blurAction();
            }
        }, 50);
    };

    inputValid = (title) => (event) => {
        let empty = true;
        if (!event.target.value && this.props.required) {
            empty = false;
        }
        this.setState({
            emptyValidation: empty,
        });
        this.props.inputValid(title, event.target.value);
    };

    render() {
        const {
            title,
            placeholder,
            type,
            rows,
            disabled,
            _isShowLabel,
            message,
            maxlength,
            required,
            testid,
        } = this.props;
        const {emptyValidation} = this.state;
        return (
            <div
                className={
                    emptyValidation ? 'basic-textarea' : 'basic-textarea empty'
                }>
                {typeof _isShowLabel === 'undefined' ? (
                    <label className="textarea-title">
                        {required ? (
                            <span className="form-required">*</span>
                        ) : null}
                        {T(title)}
                    </label>
                ) : null}
                <textarea
                    className="textarea-content"
                    testid={testid ? testid : ''}
                    onChange={this.inputValid(
                        typeof message !== undefined ? message : title,
                    )}
                    placeholder={
                        emptyValidation ? T(placeholder) : T('required')
                    }
                    type={type || 'text'}
                    rows={rows}
                    maxlength={maxlength}
                    ref={(input) => (this.input = input)}
                    onBlur={this.blurAction}
                    onFocus={this.foucusInput}
                    disabled={disabled}
                />
                {this.input && this.input.value ? (
                    <Cancel
                        className="cancel-button"
                        testid={testid ? `${testid}-cancel` : ''}
                        onClick={this.clearInput}
                    />
                ) : null}
            </div>
        );
    }
}

BasicTextArea.propTypes = {
    title: PropTypes.string.isRequired,
};

export default BasicTextArea;
